<template>
	<div class="hpc-list">
		<div class="hpc-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">HPC Solutions</span>
			</div>

			<div class="list">
				<ul class="">
					<li>
						<img :src="solution_image_02" alt="Xhorse"/>
						<div class="tt">
							<div class="hh">Ultra-scale FPGA accelerator card</div>
							<ul class="dd">
								<li>
									<div class="dot">·</div>
									<div>
										Xhorse self-developed Ultra-scale FPGA accelerator card is based on the XCKU115 chip invented by XILINX. Based on a 20nm technology, this chip has both powerful functions and high energy efficiency ratio.
									</div>
								</li>

								<li>
									<div class="dot">·</div>
									<div>
										With high-performance computing, the accelerator card, compatible with various common interfaces, supports various algorithms and switch processing between multiple algorithms by supporting the free switching of multiple mirrored versions.
									</div>
								</li>

								<li>
									<div class="dot">·</div>
									<div>
										The self-developed host computer can remotely monitor the status of the card, and support operations such as remote boot and shut down and remote upgrade, which makes management and maintenance easier.
									</div>
								</li>
							</ul>
						</div>
					</li>
					<li>
						<img :src="solution_image_01" alt="Xhorse"/>
						<div class="tt">
							<div class="hh">HPC  Acceleration Platform</div>
							<ul class="dd">
								<li>
									<div class="dot">·</div>
									<div>Based on the Xhorse self-developed Ultra-scale FPGA cloud computing accelerator
										card, Xhorse had successfully built the FPGA computing platform which is easy to develop and maintain.
									</div>
								</li>

								<li>
									<div class="dot">·</div>
									<div>The powerful computing platform supports high-performance concurrent computing
										which has a significant acceleration effect on specific algorithms.
									</div>
								</li>

								<li>
									<div class="dot">·</div>
									<div>The HPC platform can be compatible with a variety of common hardware
										interfaces, and provide a unified software interface for various algorithms.
									</div>
								</li>

								<li>
									<div class="dot">·</div>
									<div>
										All the self-developed software and hardware facilities of the platform formed a
										closed ecological system that ensures the great adaptability between the software and the hardware.
									</div>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_hpc_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_hpc_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02
            };
        }
    }

</script>

<style scoped="">
	.dot {
		width: .625rem;
	}

	.dd > li > div:not(.dot) {
		width: calc(100% - .625rem);
	}

	.dd > li > div {
		float: left;
		margin-bottom: 1.375rem;
	}

	.dd > li {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 1.375rem;
		margin-top: 1.375rem;
	}

	.tt > .hh, .tt > .dd {
		width: 100%;
		border: none;
	}

	.tt > .hh {
		margin-top: 1.375rem;
		font-size: 1rem;
		color: #3B3A38;
		letter-spacing: 0;
		text-align: justify;
	}

	.list > ul > li > .tt {
		height: 406px;
		width: 100%;
	}

	.list > ul > li > img {
		width: 100%;
	}

	.list > ul > li {
		width: 100%;
		height: 45.375rem;
	}

	.list > ul > li:first-child {
		border-bottom: 1px solid #D7D7D7;
		margin-bottom: 6.125rem;
	}

	.list > ul {
		width: 100%;
		height: 90.75rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		height: 90.75rem;
		border: none;
		margin-left: 7rem;
	}

	.hpc-con {
		width: 61.5rem;
		height: 104.8125rem;
		margin-left: 0;
	}

	.hpc-list {
		width: 100%;
		height: 1677px;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-hpc.vue